import clsx from 'clsx'
import IntLink from 'components/common/IntLink'
import useSlug from 'hooks/useSlug'
import { isDiff, isSame } from 'lib/utils'

import { ICategory } from 'store/api'

let CategorySubs = ({ slug: categorySlug, name, sub }: ICategory) => {
  let { slug } = useSlug()

  return (
    <div className='overflow-x-auto omit-scrollbar flex gap-2 mt-2 lg:m-0 pl-1 md:pl-0 md:pb-2 lg:flex-wrap'>
      <div
        className={clsx(
          'rounded-lg p-2 whitespace-nowrap font-semibold text-sm leading-snug tracking-tight',
          {
            'bg-lightGrey text-bodyGrey hover:bg-lightYellow':
              slug?.length === 2,
            'bg-primary text-dark':
              isSame(categorySlug, slug![0]) && slug?.length === 1,
          }
        )}
      >
        <IntLink
          className={clsx('whitespace-nowrap tracking-tight', {
            'lg:text-dark':
              isSame(categorySlug, slug![0]) && slug?.length === 1,
          })}
          href={`/categories/${categorySlug}`}
        >
          Все {name.toLowerCase()}
        </IntLink>
      </div>

      {sub.map((x) => (
        <div
          key={x.id}
          className={clsx(
            'rounded-lg p-2 whitespace-nowrap font-semibold text-sm leading-snug tracking-tight',
            {
              'bg-lightGrey text-bodyGrey hover:bg-lightYellow':
                isDiff(x.slug, slug![1]),
              'bg-primary text-dark ': isSame(x.slug, slug![1]),
            }
          )}
        >
          <IntLink
            className={clsx('whitespace-nowrap tracking-tight', {
              'lg:text-dark': isSame(x.slug, slug![1]),
            })}
            href={`/categories/${categorySlug}/${x.slug}`}
          >
            {x.name}
          </IntLink>
        </div>
      ))}
    </div>
  )
}

export default CategorySubs
